import { useState } from "react";
import ChevronDown from "assets/chevron-down.svg";
import ChevronUp from "assets/chevron-up.svg";
import DriveImage from "assets/drive-image.png";
import { useTranslation } from "react-i18next";
import { itemsEn, itemsFr } from "./utils";

export default function SmartcomplyDrive() {
  const [activeIndex, setActiveIndex] = useState(0);

  const { t } = useTranslation("about");
  const language = localStorage.getItem("selectedLanguage");

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const items = language?.includes("fr") ? itemsFr : itemsEn;
  return (
    <div className="flex !justify-between items-center flex-col xl:flex-row px-6 md:px-14 py-[7rem] gap-[5rem] xl:gap-[14rem]">
      <div className="xl:w-[50%] space-y-4">
        <h2 className="text-black text-[36px] md:text-[44px] font-semibold font-lexend leading-[48px] txt-center">
          {t("drive.title")}
        </h2>
        <p className="text-[#00000066] text-xl font-lexend font-normal">
          {t("drive.subTitle")}
        </p>
        <div className="flex pt-5">
          <div className="flex-1 space-y-6">
            {items.map((item, index) => {
              const isOpen = activeIndex === index;

              return (
                <div key={index} className="flex gap-4">
                  <div
                    className={`w-[4px] rounded transition-all duration-300 ${
                      isOpen ? "bg-black" : "bg-gray-200"
                    }`}
                  />

                  <div className="flex-1 space-y-2">
                    <button
                      onClick={() => toggle(index)}
                      className="flex w-full items-center justify-between text-left"
                    >
                      <h4 className="text-xl font-semibold text-black font-lexend">
                        {item.title}
                      </h4>

                      <img
                        src={isOpen ? ChevronUp : ChevronDown}
                        alt="icon"
                        className="w-[14px] h-[10px]"
                      />
                    </button>

                    {/* Body */}
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        isOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                      }`}
                    >
                      <p className="text-[#00000066] leading-relaxed text-xl font-lexend w-[95%] md:w-[80%]">
                        {item.content}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="xl:w-[50%]">
        <img
          src={DriveImage}
          alt="DriveImage"
          className="w-[610px] xl:h-[569px]"
        />
      </div>
    </div>
  );
}
